/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCommentingConfig } from '../../../../state/thunks/commenting';
// utils
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "../../../../material/structure/pageheader/pageheader";
import PageContent from "../../../../material/structure/pagecontent/pagecontent";
import SiteFilter from '../../../../material/sitefilter/sitefilter';
import LoadingState from '../../../../material/states/loading/loading';
// content
import CommentingAdvancedSection from './advanced/advanced';
import CommentingExportSection from './export/export';
// styles
import injectSheet from "react-jss";
import styles from './commentingadvanced_styles';

/* ========== ~~~~~~~~~~ COMMENTING: ADVANCED PAGE ~~~~~~~~~~ ========== */
const CommentingAdvancedPage = injectSheet(styles)((props) => {

  const dispatch = useDispatch();
  const { sites } = useSelector(state => state.account) 
  const { siteUUID, accountUUID } = useSelector(state => state.session);
  const { commentingConfig } = useSelector(state => state.commenting)

  const [isLoading,setIsLoading] = useState(true)

  useEffect(() => {
    if(accountUUID && siteUUID) loadCommentingConfig()
  }, [accountUUID, siteUUID]) 

  const loadCommentingConfig = useCallback(async()=>{
    const response = await dispatch(fetchCommentingConfig({accountUUID, siteUUID, siteURL: sites[siteUUID] }))
    setIsLoading(false)
  }, [siteUUID, accountUUID])

  return (
    <Page name={'commentingadvancedpage'} klass={`${props.classes.commentingadvancedpage}`}>
      <SiteFilter />
      <Content>
        <InContentMessage />
        <PageHeader title={'Commenting'} subtitle={'Advanced'}  />
        <PageContent>
          { isLoading || commentingConfig.status === 'pending' ?
            <LoadingState />
            : 
            <>
              <CommentingExportSection />
              <CommentingAdvancedSection />
            </>
          }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentingAdvancedPage